import { Card, useMediaQuery, useTheme } from '@mui/material';
import { TimelineQRBubbleProps } from '../timeline.types';
import { useTimelineQRBubbleStyles } from './timeline-qr-bubble.styles';
import { QrCode } from '../../qr-code/qr-code.component';

export function TimelineQRBubble({ qrCode, title, message }: TimelineQRBubbleProps) {
  const classes = useTimelineQRBubbleStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return isMobile ? (
    <Card className={classes.mobileCard}>
      <p className={classes.title}>{title}</p>
      {qrCode ? <QrCode qrCode={qrCode} /> : null}
      <p className={classes.message}>{message}</p>
    </Card>
  ) : (
    <Card className={classes.desktopCard}>
      {qrCode ? <QrCode qrCode={qrCode} /> : null}
      <div>
        <p className={classes.title}>{title}</p>
        <p className={classes.message}>{message}</p>
      </div>
    </Card>
  );
}
